import React, { useEffect } from 'react';
// @ts-ignore
import { useLocation } from 'react-router-dom';
import Online from '../../../assets/images/online.png';
import ListGroup from 'react-bootstrap/ListGroup';
import Quest from '../../../assets/images/quest.svg';



import './styles.css';
import ChecklistPurchase from '../Planos/components/ChecklistPurchase';

const Orientacao = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [location.pathname]);

  return (
    <div className="container">
      <div className="row">
        <div className='orientacao'>
          <h3>Orientações para auxiliar o nosso cliente escolher o Plano de Conexão Ideal</h3>
        </div>
        <div className="col-sm-12 col-md-4">
          <div className="info">
            <img src={Online} alt="Foto" />
          </div>
        </div>
        <div className="col-sm-12 col-md-8">
          <div className="info">
            <span>
              Na hora de escolher o plano perfeito, precisamos analisar a quantidade de dispositivos que o cliente deseja conectar, as atividades que serão realizadas e a demanda de banda necessária. Com base nessas informações, recomendaremos o plano mais adequado para garantir uma conexão estável e de alta qualidade.
              <hr />
              <p>Para uma experiência ideal ao reproduzir vídeos, seguem nossas recomendações de velocidade de conexão:</p>
              <ol>
                <li>
                  Navegação na Web: Acessar sites, redes sociais e e-mails requer uma quantidade moderada de banda. Planos com velocidades a partir de 5 Mbps são geralmente suficientes para atender às necessidades básicas para até 3 dispositivos.
                </li>
                <li>Vídeos em <strong>HD (720p)</strong>: Recomendamos uma velocidade mínima de <strong>5 Mbps</strong> para reprodução suave e sem interrupções.</li>
                <li>Vídeos em <strong>Full HD (1080p)</strong>: É indicado ter uma velocidade de conexão de pelo menos <strong>10 Mbps</strong> para uma visualização com qualidade.</li>
                <li>Vídeos em <strong>UHD (4K)</strong>: Para aproveitar vídeos em resolução 4K, recomendamos uma velocidade de conexão de pelo menos <strong>25 Mbps</strong>, garantindo um streaming sem problemas.</li>
                <li>
                  Chamadas de Vídeo: Realizar videochamadas em plataformas como Zoom, Microsoft Teams ou Skype requer uma conexão estável. velocidades a partir de 15 Mbps são ideais para uma experiência sem interrupções.
                </li>
                <li>
                  Jogos Online: Para jogadores entusiastas, é essencial contar com planos a partir de 30 Mbps para garantir baixa latência e evitar atrasos durante as partidas.
                </li>
              </ol>
              <p>
                Lembre-se de considerar outros fatores, como o número de dispositivos simultâneos e atividades adicionais que consomem banda, ao escolher o plano mais adequado às suas necessidades. Nossa equipe está à disposição para fornecer informações adicionais e ajudá-lo(a) a selecionar o plano ideal.
              </p>
            </span>
          </div>
        </div>
      </div>
      <br />
      <hr />
      <br />
      <div className='row'>
        <div className='col-sm-12 col-md-8'>
          <h4>Questionário para Recomendação de Plano de Internet:</h4>
          <div className='quest'>
            <ListGroup as="ol" numbered>
              <ListGroup.Item as="li">
                <span>Quantas pessoas irão utilizar a conexão de internet em média?</span>
                <p>Esse dado é importante para dimensionar a demanda de uso da internet em sua residência ou empresa.</p>
              </ListGroup.Item>
              <ListGroup.Item as="li">
                <span>
                  Haverá a utilização de IPTV (TV por Internet), Streaming de vídeos como Netflix, Youtube, etc.?
                </span>
                <p>
                  Se o cliente irá utilizar serviços de streaming ou IPTV, é importante considerar a velocidade da conexão para garantir uma experiência de visualização sem interrupções.
                </p>
              </ListGroup.Item>
              <ListGroup.Item as="li">
                <span>Quantos dispositivos serão conectados simultaneamente?</span>
                <p>Saber quantos dispositivos serão conectados à internet ao mesmo tempo é essencial para escolher um plano que atenda a essa demanda.</p>
              </ListGroup.Item>
              <ListGroup.Item as="li">
                <span>Existe a necessidade de altas velocidades de download/upload para transferência de arquivos grandes?</span>
                <p>Se você ou sua empresa realiza frequentemente transferências de arquivos grandes, é recomendado optar por planos de alta velocidade de download/upload para maior eficiência.</p>
              </ListGroup.Item>
              <ListGroup.Item as="li">
                <span>Serão realizados jogos online?</span>
                <p>Para jogadores que desejam evitar atrasos e quedas de conexão durante os jogos online, é importante considerar planos com velocidades mais altas e menor latência.</p>
              </ListGroup.Item>
              <ListGroup.Item>
                <span>Qual a principal finalidade da conexão? Uso doméstico ou empresarial?</span>
                <p>A finalidade da conexão, se para uso doméstico ou empresarial, também influencia na escolha do plano ideal, considerando as necessidades específicas de cada ambiente.</p>
              </ListGroup.Item>
              <ListGroup.Item>
                <span>Haverá necessidade de suporte técnico especializado?</span>
                <p>Algumas empresas e usuários podem necessitar de suporte técnico dedicado para garantir a estabilidade e qualidade da conexão de internet.</p>
              </ListGroup.Item>
              <ListGroup.Item>
                <span>É importante ter um IP fixo?</span>
                <p>Para fins empresariais ou serviços que requeiram IP fixo, é relevante avaliar essa opção ao escolher o plano de internet.</p>
              </ListGroup.Item>
            </ListGroup>
          </div>
          <span><br />
            Com base nas respostas, será possível recomendar o plano de internet mais
            adequado às necessidades de conexão.
            Nossa missão é ajudar nosso cliente a tomar a decisão que irá proporcionar a melhor experiência na internet.
            <br />
          </span><br /><br />
          <p>
            Independentemente do perfil do cliente, nossos planos são projetados para atender às necessidades específicas de nossos clientes, proporcionando uma experiência de internet de alta qualidade e confiabilidade.
          </p>
        </div>
        <div className='col-sm-12 col-md-4'>
          <img src={Quest} alt="Foto" />
        </div>
      </div>
      <div>
        <hr />
        <ChecklistPurchase />
      </div>
    </div>
  );
};

export default Orientacao;
